import { render, staticRenderFns } from "./yc-sales-volume-summary.vue?vue&type=template&id=34715942&scoped=true&"
import script from "./yc-sales-volume-summary.vue?vue&type=script&lang=js&"
export * from "./yc-sales-volume-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34715942",
  null
  
)

export default component.exports